<template>
	<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path d="M19 7.27463L17.59 5.78003L12 11.7054L6.41 5.78003L5 7.27463L10.59 13.2L5 19.1254L6.41 20.62L12 14.6946L17.59 20.62L19 19.1254L13.41 13.2L19 7.27463Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>